module.exports = __webpack_public_path__ + "static/media/VaderPay_QR.f0fc88a7.svg";